import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "theme-container"
};
const _hoisted_2 = {
  class: "news-list-container"
};
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = {
  class: "search-btn"
};
const _hoisted_5 = {
  class: "theme-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "list-item"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "item-title"
};
const _hoisted_10 = {
  key: 0,
  class: "item-text"
};
const _hoisted_11 = {
  key: 1,
  class: "item-text"
};
const _hoisted_12 = {
  class: "item-bottom"
};
const _hoisted_13 = {
  class: "info-item"
};
const _hoisted_14 = {
  class: "info-item"
};
const _hoisted_15 = {
  class: "info-item"
};
const _hoisted_16 = ["title"];
const _hoisted_17 = {
  class: "info-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "banner"
  }, [_createElementVNode("img", {
    src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/89ac66a85d46446995aea5089e3d18f9.png"
  })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "label"
  }, [_createElementVNode("img", {
    src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/3269f025849b42c780e83178cb1bfe44.png"
  }), _createElementVNode("span", null, "工程案例介绍")], -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleSearchCase && $options.handleSearchCase(...args))
  }, _cache[1] || (_cache[1] = [_createElementVNode("span", {
    class: "text"
  }, "查看工程案例资源", -1), _createElementVNode("div", {
    class: "arrow"
  }, null, -1)]))])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "case-intro"
  }, " 哈尔滨工程大学充分发挥“三海一核”办学特色与工科优势，积极推进工程类案例建设，聚焦船舶与海洋工程、动力工程、信息工程等重点领域，深入挖掘重大工程项目中的关键技术问题与创新实践经验。学校鼓励教师将科研成果转化为教学资源，组织团队深入企业一线，提炼典型工程实践案例，形成一批具有代表性、实用性和推广价值的高质量案例。相关案例广泛应用于专业学位研究生教学，有效提升了学生解决复杂工程问题的能力，强化了产教融合育人机制，推动了工程类专业学位研究生培养模式的改革与创新。 ", -1)), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "theme-title"
  }, [_createElementVNode("img", {
    src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/ffbf65e67dd2466686380f44e0cd0e3d.png"
  })], -1)), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.caseLevelList, item => {
    return _openBlock(), _createElementBlock("div", {
      onClick: $event => $options.handleCaseLevelChange(item.id),
      class: _normalizeClass(["theme-item", {
        active: $data.caseLevelId == item.id
      }])
    }, _toDisplayString(item.name), 11, _hoisted_6);
  }), 256))]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.caseBuildList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "case-item",
      onClick: $event => $options.handleCaseClick(item)
    }, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.case_name), 1), item.remark ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.remark), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_11, "--")), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[3] || (_cache[3] = _createElementVNode("img", {
      src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/abbab6cdb4854d5291c70c0639fb9d5b.png"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(item.first_expert), 1)]), _createElementVNode("div", _hoisted_14, [_cache[4] || (_cache[4] = _createElementVNode("img", {
      src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/e31fa0b1dd4c4ddd8d14d7d8c947d954.png"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(item.type_name || '--'), 1)]), _createElementVNode("div", _hoisted_15, [_cache[5] || (_cache[5] = _createElementVNode("img", {
      src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/f4b4f777773345fc9fa75f72ab9e638f.png"
    }, null, -1)), _createElementVNode("span", {
      title: item.belong_college
    }, _toDisplayString(item.belong_college || '--'), 9, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [_cache[6] || (_cache[6] = _createElementVNode("img", {
      src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/46cc9dedd3fb4158ba5cf761c07fefdb.png"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(item.publish_year), 1)])])], 8, _hoisted_8);
  }), 256))]), _createVNode(_component_el_pagination, {
    "hide-on-single-page": "",
    background: "",
    layout: "prev, pager, next",
    total: $data.total,
    onCurrentChange: $options.handlePageChange,
    "current-page": $data.pageNum,
    "page-size": $data.pageSize,
    "prev-text": "上一页",
    "next-text": "下一页"
  }, null, 8, ["total", "onCurrentChange", "current-page", "page-size"])]), _createVNode(_component_Footer)]);
}